// Which posts the blog list shows after `page` loads (`?page=N`; "Load more"
// adds one). Every row of the grid in Blog.jsx stays full: the featured post
// spans two cells of the three-column grid with one card beside it, so the
// first load carries one extra card — featured (2 cells) + 13 cards is 5 rows
// of 3, and, with featured narrowing to one cell at two columns, 7 rows of 2.
// Each later load of 12 is 4 rows of 3 or 6 rows of 2.
export const LOAD_SIZE = 12;

// A post with `pinned: true` in its frontmatter (ocl_online#227) takes the
// featured slot ahead of newer ones; everything else keeps date order.
export const pagePosts = (posts, page) => {
  const pinned = posts.find(post => post?.pinned === true);
  const ordered = pinned ? [pinned, ...posts.filter(post => post !== pinned)] : posts;
  const [featured = null, ...others] = ordered;
  const pageCount = Math.max(1, Math.ceil(Math.max(0, others.length - 1) / LOAD_SIZE));
  const current = Math.min(Math.max(1, page), pageCount);
  return { featured, rest: others.slice(0, 1 + current * LOAD_SIZE), page: current, hasMore: current < pageCount };
};
